import { useQuery } from '@tanstack/react-query';

import { useFDMServices } from '../../../providers/fdm-services/fdm-services.context';
import { QueryKeys } from '../../../utils/queryKeys';

// We have to do this silly dance because the browser isn't authenticated to
// fetch the image, so we need to download the image and then serve it back
// to the <img /> tag via a `blob:garbage` URL.
// TODO(OI-1009): Remove this nonsense and just hand it the actual thumbnail.
export const useFetchImageByUrl = (imageURL?: string) => {
  const { mediaService } = useFDMServices();

  const queryResult = useQuery<string>({
    queryKey: [QueryKeys.MEDIA_ITEM, imageURL],
    queryFn: async () => {
      return mediaService.getMediaByUrl(imageURL!);
    },
    meta: { error: { captureError: true } },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: Boolean(imageURL),
  });

  return {
    data: queryResult.data,
    isLoading: queryResult.isLoading,
  };
};
